/**
 * Transcribed from `GigsafeDefaultUseRoles` in para-node
 * `src/constants/gigsafe-user-access/gigsafe-user-role.constants.ts`.
 *
 * Used for one decision: whether the role form is read-only.
 * `GigsafeUserRolesApiService.update` throws `Default roles are not modifiable` for any of these,
 * and `@IsNotIn(Object.values(GigsafeDefaultUseRoles))` also blocks naming a NEW role after one.
 * Unlike the permission list, this is five stable values the app has to reason about, so it is a
 * real enum.
 */
export enum GigsafeDefaultRoleName {
  SuperAdmin = 'super_admin',
  Owner = 'owner',
  Admin = 'admin',
  Manager = 'manager',
  CustomerOnboarding = 'customer_onboarding',
}

export enum GigsafeUsersTableFields {
  id = 'id',
  name = 'name',
  email = 'email',
  disabled = 'disabled',
  disabledAt = 'disabledAt',
}
